
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stories/eyes-on-equality",
      function () {
        return require("private-next-pages/stories/eyes-on-equality.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stories/eyes-on-equality"])
      });
    }
  